// Buyer roles worth putting in a campaign.
//
// Shared by the campaign builder and the add-people flow inside a campaign,
// because "these companies, CFOs and COOs only" has to mean the same thing in
// both places. The pattern is sent to the server as a string and rebuilt
// there, so the two ends cannot drift.
export const ROLE_FILTERS = [
  { key: 'finance', label: 'CFO / finance', re: /chief financial|CFO|finance|treasur|controller/i },
  { key: 'procurement', label: 'Procurement', re: /procurement|sourcing|purchas|CPO\b/i },
  { key: 'operations', label: 'Operations / supply chain', re: /operating|operations|supply chain|manufactur|plant|COO\b/i },
  { key: 'digital', label: 'Digital / IT', re: /digital|information officer|CIO\b|CTO\b|technology|transformation|data|analytics/i },
  { key: 'exec', label: 'CEO / board', re: /chief executive|CEO\b|president|chair/i },
]

export const roleSource = (key) => ROLE_FILTERS.find((r) => r.key === key)?.re.source || null
